import { gsap } from 'gsap';
// Menu functie
let tl = gsap.timeline({ reversed: true })
tl.to('.mobile-navigation-container', {height: '100vh', duration: 0.4, delay: 0})
.to('.searchform', { opacity: 1, duration: 0.5, delay: 0}, '<')
.to('#menu-main li', {opacity: 1, duration: 0.5, delay: 0, stagger: 0.1}, '<')
.to('#menu-top li', { opacity: 1, duration: 0.5, x: 0, delay: 0, stagger: 0.2}, '<')
const myAnimation = () => {
  tl.reversed(!tl.reversed())
}
document.querySelector('.hamburger').addEventListener('click', myAnimation)

// Hamburger navigatie (streepjes naar kruisje) + body-class
var controlit = $('.hamburger');

var menuToggle = new gsap.timeline({paused:true, reversed:true});
let bool = false;
let body = document.querySelector('body')
menuToggle  
  .to(' .bar1', 0.1, {y:'-10px', transformOrigin: '50% 50%'})
  .to(' .bar3', 0.1, {y:'10px', transformOrigin: '50% 50%'}, '<')
  .to(' .bar2', 0.1, {scale:0.1, transformOrigin: '50% 50%'}, '<')
  .add('rotate')
  .to(' .bar1', 0.1, {y:'10'}, 'rotate')
  .to(' .bar3', 0.1, {y:'-10'}, 'rotate')
  .to(' .bar1', 0.1, {rotationZ:45, transformOrigin: '50% 50%'}, '<')
  .to(' .bar3', 0.1, {rotationZ:-45, transformOrigin: '50% 50%'}, '<')
  .to(' .bar3', 0.1, {rotationZ:-45, transformOrigin: '50% 50%'}, '<')
controlit.click(function () {
  menuToggle.reversed() ? menuToggle.restart() : menuToggle.reverse();
  if (bool === false) {
    body.classList.add('stop-scroll');
    bool = true;
  } else {
    body.classList.remove('stop-scroll');
    bool = false;
  }
});
